import { config } from "./config";
import { getSessionId } from "./utils";

export const ABORT_REQUEST_CONTROLLERS = new Map<string, AbortController>();

export const abortRequest = (key: string, reason = "CANCELLED") => {
  ABORT_REQUEST_CONTROLLERS.get(key)?.abort?.(reason);
};

export const abortAndGetNewSignal = (key: string) => {
  abortRequest(key); // abort previous request if any
  const abortController = new AbortController();
  ABORT_REQUEST_CONTROLLERS.set(key, abortController);
  return abortController.signal;
};

export const abortPreviousRequestsIfAny = (...keys: string[]) => {
  keys.forEach((key) => abortRequest(key));
};

export const createKey = (httpMethod: string, url: string) =>
  `${httpMethod} ${url}`;

export const getImageUrlKey = () =>
  createKey("GET", `${config.apiBasePath}/v1/image/${getSessionId()}`);
export const getAnalysisUrlKey = () =>
  createKey("POST", `${config.apiBasePath}/v1/analysis`);
export const getServiceProviderDetailsUrlKey = (systemSize: number) =>
  createKey(
    "GET",
    `${
      config.apiBasePath
    }/v1/service-provider-details/${getSessionId()}?systemSize=${systemSize}`
  );
export const getServiceProviderDetailsRatingReviewsUrlKey = (
  ids: string | null
) =>
  createKey(
    "GET",
    `${
      config.apiBasePath
    }/v1/service-provider-details-rating-reviews?serviceProviderIds=${encodeURIComponent(
      ids ?? ""
    )}`
  );
export const getServiceabilityAddressUrlKey = () =>
  createKey("POST", `${config.apiBasePath}/v1/serviceability/address`);
export const getServiceabilityBuildingUrlKey = () =>
  createKey("POST", `${config.apiBasePath}/v1/serviceability/building`);
export const getQuoteUrlKey = () =>
  createKey("GET", `${config.apiBasePath}/v1/quote/${getSessionId()}`);
export const getSolarBatteryUrlKey = () =>
  createKey(
    "GET",
    `${config.apiBasePath}/v1/solar-battery/outlook/${getSessionId()}`
  );
export const getSessionIdUrlKey = () =>
  createKey("POST", `${config.apiBasePath}/v1/session-id`);
export const getUsageUrlKey = () =>
  createKey("POST", `${config.apiBasePath}/v1/usage`);
